import React from 'react';
import { Check } from 'lucide-react';

export const PHASES = [
  { key: 'exploration',  label: 'Exploración',  color: '#E27B58' },
  { key: 'analysis',     label: 'Análisis',      color: '#F39C12' },
  { key: 'negotiation',  label: 'Negociación',   color: '#9B59B6' },
  { key: 'project',      label: 'Proyecto',      color: '#3498DB' },
  { key: 'opening',      label: 'Apertura',      color: '#27AE60' },
  { key: 'operational',  label: 'Operativo',     color: '#2ECC71' },
];

export const PHASE_COLOR = Object.fromEntries(PHASES.map(p => [p.key, p.color]));
export const REJECTED_COLOR = '#E74C3C';

const PhaseTimeline = ({ currentPhase, onSelectPhase, compact = false }) => {
  const currentIndex = PHASES.findIndex(p => p.key === currentPhase);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 0,
      overflowX: 'auto',
      padding: compact ? '8px 0' : '12px 0',
    }}>
      {PHASES.map((phase, i) => {
        const isPast = i < currentIndex;
        const isCurrent = i === currentIndex;
        const color = phase.color;

        return (
          <React.Fragment key={phase.key}>
            {/* Step */}
            <div
              onClick={() => onSelectPhase && onSelectPhase(phase.key)}
              title={phase.label}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '5px',
                cursor: onSelectPhase ? 'pointer' : 'default',
                opacity: isPast || isCurrent ? 1 : 0.4,
                transition: 'opacity 0.2s',
                flexShrink: 0,
              }}
            >
              <div style={{
                width: compact ? 28 : 34,
                height: compact ? 28 : 34,
                borderRadius: '50%',
                background: isCurrent ? color : isPast ? `${color}55` : 'rgba(255,255,255,0.06)',
                border: `2px solid ${isCurrent || isPast ? color : 'rgba(255,255,255,0.1)'}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: isCurrent ? `0 0 14px ${color}88` : 'none',
                transition: 'all 0.3s',
              }}>
                {isPast ? (
                  <Check size={compact ? 12 : 14} color={color} />
                ) : (
                  <span style={{
                    fontSize: compact ? '0.6rem' : '0.65rem',
                    color: isCurrent ? '#fff' : '#666',
                    fontWeight: 'bold',
                    fontFamily: 'monospace',
                  }}>
                    {i + 1}
                  </span>
                )}
              </div>
              {!compact && (
                <span style={{
                  fontSize: '0.6rem',
                  color: isCurrent ? color : isPast ? `${color}99` : '#444',
                  fontWeight: isCurrent ? '700' : '400',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  whiteSpace: 'nowrap',
                  maxWidth: 60,
                  textAlign: 'center',
                }}>
                  {phase.label}
                </span>
              )}
            </div>

            {/* Connector */}
            {i < PHASES.length - 1 && (
              <div style={{
                flex: 1,
                height: 2,
                minWidth: compact ? 12 : 20,
                background: isPast
                  ? `linear-gradient(90deg, ${color}88, ${PHASES[i + 1].color}44)`
                  : 'rgba(255,255,255,0.07)',
                marginBottom: compact ? 0 : 20,
                transition: 'background 0.3s',
              }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default PhaseTimeline;
